import React from 'react';

interface IAmountProps {
    value?: Number;
}

function numberWithCommas(num: number) {
    return num.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export default function Amount(props: IAmountProps) {
    let value = props.value;
    if (!value)
        return null;
    let krValue = +value / 100;
    let fmtKrValue = numberWithCommas(krValue);
    return <>{fmtKrValue}</>
}
